import { Container, Typography } from "@mui/material";
import { StatusUser, StatusInternalRequest } from "@/components/common";
import { SystemConstant } from "@/const";

const Status = () => {
  return (
    <Container sx={{ display: "flex", flexDirection: "column", gap: 1, paddingTop: 1 }}>
      <Typography variant="subtitle1">User</Typography>
      <StatusUser status={SystemConstant.STATE.active} />
      <StatusUser status={SystemConstant.STATE.inactive} />
      <Typography variant="subtitle1">Request</Typography>
      <StatusInternalRequest status={SystemConstant.STATUS_REQUEST.created} />
      <StatusInternalRequest status={SystemConstant.STATUS_REQUEST.pendingSend} />
      <StatusInternalRequest status={SystemConstant.STATUS_REQUEST.success} />
      <StatusInternalRequest status={SystemConstant.STATUS_REQUEST.failed} />
    </Container>
  );
};

export default Status;
